import { TMVendorInvoiceAPI } from '@business/api/tm_vendor_invoice';
import { TimeMaterialId } from '@business/entities/tm';
import { TMInvoiceScheduleId } from '@business/entities/tm/TMInvoiceScheduleResponse';
import { TMVendorInvoiceId, TMVendorInvoiceResponse } from '@business/entities/tm/TMVendorInvoiceResponse';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { VendorInvoiceFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/VendorInvoiceTab/VendorInvoice';
import { switchMap } from 'rxjs/operators';

export class TMVendorInvoiceBloc extends BaseBloc {
  private readonly typeRepo = new Repository<TMVendorInvoiceResponse>({
    getItemId: item => item.id,
  });

  readonly vendorInvoices$ = this.typeRepo.items$;
  readonly selectTMVendorInvoice = this.typeRepo.selectItem;

  onReset() {
    this.typeRepo.reset();
  }

  fetchInvoices = (tmId?: TimeMaterialId) => {
    return TMVendorInvoiceAPI.fetchVendorInvoices(tmId).pipe(
      this.typeRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_vendor_invoice_error') }),
    );
  };

  fetchInvoice = (id: TMVendorInvoiceId) => {
    return TMVendorInvoiceAPI.fetchVendorInvoice(id).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_vendor_invoice_error') }),
    );
  };

  createInvoice = (data: Partial<TMVendorInvoiceResponse>) => {
    return TMVendorInvoiceAPI.createVendorInvoice(data).pipe(
      this.typeRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_vendor_invoice'),
      }),
    );
  };

  updateInvoice = (id: TMVendorInvoiceId, data: Partial<TMVendorInvoiceResponse>) => {
    return TMVendorInvoiceAPI.updateVendorInvoice(id, data).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_vendor_invoice'),
      }),
    );
  };

  deleteInvoice = (id: TMVendorInvoiceId) => {
    return showDeleteConfirmation('Delete Vendot Invoice', 'Do you really want to remove this Vendor Invoice?').pipe(
      switchMap(() => TMVendorInvoiceAPI.deleteVendorInvoice(id)),
      this.typeRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_vendor_invoice'),
      }),
    );
  };

  createInvoices = (tmId: TimeMaterialId, data: VendorInvoiceFormData) => {
    return TMVendorInvoiceAPI.createVendorInvoices(tmId, data).pipe(
      this.typeRepo.ops.addMany(items => items),
      handleMessage({
        type: requestMessage('create_vendor_invoice'),
      }),
    );
  };

  attachInvoice = (id: TMVendorInvoiceId, invoiceId: TMInvoiceScheduleId) => {
    return TMVendorInvoiceAPI.attachVendorInvoice(id, invoiceId).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_vendor_invoice'),
      }),
    );
  };
}
